import classNames from 'classnames'
import { size, take } from 'lodash-es'
import { useCallback, useMemo } from 'react'
import { useBoolean } from 'react-use'

export default function useViewAll(data, minCount = 3) {

  const [displayAll, toggleDisplayAll] = useBoolean(false)
  const viewData = useMemo(() => {
    return displayAll ? data : take(data, minCount)
  }, [data, displayAll, minCount])
  const ToggleButton = useMemo(() => getToggleButton(data, minCount, displayAll, toggleDisplayAll), [data, minCount, displayAll, toggleDisplayAll])

  return [
    viewData,
    ToggleButton,
    displayAll,
    toggleDisplayAll
  ]
}

function getToggleButton(data, minCount, displayAll, toggleDisplayAll) {
  return function ToggleButton({
    className,
    btnClassName,
    showAllLabel = 'View more',
    showLessLabel = 'View less',
    arrow = false
  }) {
    const clickHandle = useCallback(() => toggleDisplayAll(), [])
    if (size(data) <= minCount) return

    return (
      <div className={className} onClick={clickHandle}>
        <span className={btnClassName}>{displayAll ? showLessLabel : showAllLabel}</span>
        {
          arrow && (<i className={classNames('icon ml-4', displayAll ? 'icon-arrow-up' : 'icon-arrow-down')}></i>)
        }
      </div>
    )
  }
}